/* Prozone B2B — pz-b2b.js
   Mini-panier, commande rapide (SKU + CSV), actions rapides sur la recherche.
   Dépend de window.pzB2B (voir snippets/pz-b2b-config.liquid). */
(function () {
  'use strict';

  var CFG = window.pzB2B || {};
  var R = CFG.routes || {};
  var T = CFG.i18n || {};

  /* ── Utilitaires ────────────────────────────── */

  /* Graphie suisse : apostrophe pour les milliers, point pour les décimales,
     devise en préfixe — la même que `{{ amount_with_apostrophe_separator }}`
     côté Liquid. `style: 'currency'` en fr-CH donnait « 1 828.80 CHF », donc
     une graphie différente de celle des pages rendues par le thème. */
  var fmt = new Intl.NumberFormat('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(cents) { return (CFG.currency || 'CHF') + ' ' + fmt.format((cents || 0) / 100); }

  /* ── i18n ───────────────────────────────────── */

  /* Le JS n'a pas accès au filtre `| t`. Les chaînes traduites arrivent par
     window.pzB2B.i18n (voir snippets/pz-b2b-config.liquid) avec des jetons
     littéraux %count%, %unit%, %price%, %from% que `tr` remplace ici. */
  function tr(tpl, vars) {
    var s = tpl == null ? '' : String(tpl);
    if (!vars) return s;
    for (var k in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, k)) {
        s = s.split('%' + k + '%').join(String(vars[k]));
      }
    }
    return s;
  }

  /* Le français met au pluriel à partir de 2, l'allemand et l'anglais dès que
     le compte n'est pas 1 — d'où Intl plutôt qu'un `n > 1` en dur. Chaque
     chaîne comptée existe donc en deux formes dans les locales. */
  var pluralOne = (function () {
    var pr = null;
    try { pr = new Intl.PluralRules(CFG.locale || 'fr'); } catch (e) { pr = null; }
    return function (n) {
      if (pr) return pr.select(n) === 'one';
      return n <= 1;
    };
  })();

  function trn(one, other, n, vars) {
    return tr(pluralOne(n) ? one : other, vars);
  }

  /* Certains produits sont vendus au lot : le prix de ligne est celui du lot,
     pas de la pièce. L'option de conditionnement porte le libellé exact.
     Même liste de noms d'options que snippets/pz-unit.liquid. */
  var QTY_OPTIONS = ['Quantité', 'Quantity', 'Conditionnement'];
  function unitLabel(item) {
    var ovs = item.options_with_values || [];
    for (var i = 0; i < ovs.length; i++) {
      if (QTY_OPTIONS.indexOf(ovs[i].name) !== -1 && ovs[i].value) return ovs[i].value;
    }
    return T.famUnit;
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || T.genericError);
        return j;
      });
    });
  }

  function getCart() {
    return fetch(R.cartJson || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Pool de concurrence — évite de saturer le storefront sur un import CSV. */
  function pool(items, limit, worker) {
    var out = new Array(items.length);
    var i = 0;
    function next() {
      if (i >= items.length) return Promise.resolve();
      var idx = i++;
      return Promise.resolve(worker(items[idx], idx))
        .then(function (v) { out[idx] = v; })
        .catch(function () { out[idx] = null; })
        .then(next);
    }
    var runners = [];
    for (var k = 0; k < Math.min(limit, items.length); k++) runners.push(next());
    return Promise.all(runners).then(function () { return out; });
  }

  /* ── Résolution SKU → variante ──────────────────── */

  var skuCache = Object.create(null);
  var productCache = Object.create(null);

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function resolveSku(rawSku) {
    var sku = String(rawSku || '').trim();
    if (!sku) return Promise.resolve(null);
    var key = sku.toLowerCase();
    if (skuCache[key]) return skuCache[key];

    var url = '/search/suggest.json?q=' + encodeURIComponent(sku) +
      '&resources[type]=product&resources[limit]=6' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=variants.sku';

    skuCache[key] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var products = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        var handles = products.map(function (p) { return p.handle || handleFromUrl(p.url); })
          .filter(Boolean);
        if (!handles.length) return null;
        return pool(handles, 4, getProduct).then(function (loaded) {
          for (var i = 0; i < loaded.length; i++) {
            var p = loaded[i];
            if (!p || !p.variants) continue;
            for (var v = 0; v < p.variants.length; v++) {
              var variant = p.variants[v];
              if (String(variant.sku || '').trim().toLowerCase() === key) {
                return { product: p, variant: variant };
              }
            }
          }
          return null;
        });
      })
      .catch(function () { return null; });

    return skuCache[key];
  }

  /* ── Mini-panier ────────────────────────────── */

  var MC = (function () {
    var root = $('#pz-mini-cart');
    if (!root) return null;

    var panel     = $('.pz-mc__panel', root);
    var linesEl   = $('[data-pz-mclines]', root);
    var emptyEl   = $('[data-pz-mcempty]', root);
    var footEl    = $('[data-pz-mcfoot]', root);
    var countEl   = $('[data-pz-mccount]', root);
    var subEl     = $('[data-pz-mcsub]', root);
    var tpl       = $('[data-pz-mctpl]', root);
    var checkout  = $('[data-pz-mccheckout]', root);
    var lastFocus = null;
    var busy      = false;

    function open() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refresh();
      var close = $('.pz-mc__close', root);
      if (close) close.focus();
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* `meters()` a été retiré : le minimum de commande et les paliers de remise
       ne sont plus affichés. Le minimum n'était de toute façon pas opposable
       (on pouvait atteindre /checkout en direct) et aucune remise automatique
       n'existe dans Shopify. Les metafields `prozone.min_order_chf` et
       `prozone.volume_tiers` restent en place, ainsi que leur exposition dans
       window.pzB2B — il n'y a que l'affichage qui part. */

    /* Récapitulatif par gamme dans le tiroir.

       Le mini-panier se peuple depuis /cart.js, qui ne porte aucun metafield :
       la table des gammes lui est donc fournie par Liquid, un bloc JSON par
       produit (voir pz-fam-item.liquid).

       Deux portées, à ne pas confondre — c'est tout l'objet de ce bloc :
       le MINIMUM se compte sur la gamme entière et panachée (6 bocaux, quels
       qu'ils soient), les PALIERS de prix se comptent sur un modèle seul
       (12 Glass Jar pour le Glass Jar à 36.90). Une barre de gamme pour le
       premier, une ligne par modèle pour les seconds.

       Les prix des paliers arrivent déjà mis en forme par Liquid : le tiroir
       n'a ni la devise ni le format suisse à connaître. */
    var FAM = (function () {
      var out = { map: {}, packs: {}, tiers: {}, fams: {} };
      var blocks = document.querySelectorAll('script.pz-fam-item');
      if (!blocks.length) return null;
      Array.prototype.forEach.call(blocks, function (el) {
        try {
          var o = JSON.parse(el.textContent);
          out.map[o.p] = o.f;
          out.packs[o.p] = o.k > 1 ? o.k : 1;
          out.tiers[o.p] = o.s || [];
          out.fams[o.f] = {
            libelle: o.l, minimum: o.m, unite: o.u || T.famUnit,
            panachage: o.x !== false
          };
        } catch (e) {}
      });
      return out;
    })();

    function renderFamilles(cart) {
      var box = $('[data-pz-mcfam]', root);
      if (!box) return;
      box.textContent = '';
      if (!FAM || !FAM.map) return;

      var totals = {}, prods = {};
      cart.items.forEach(function (it) {
        var key = FAM.map[it.product_id];
        if (!key) return;
        /* Un lot compte pour sa taille ; vendu à la pièce, le multiplicateur
           retombe à 1. */
        var pack = (FAM.packs && FAM.packs[it.product_id]) || 1;
        var q = it.quantity * pack;
        totals[key] = (totals[key] || 0) + q;

        /* Regroupé par produit et non par ligne : deux déclinaisons d'un même
           modèle comptent ensemble pour son palier, comme à la caisse. */
        var bucket = prods[key] || (prods[key] = {});
        var e = bucket[it.product_id];
        if (e) { e.qty += q; }
        else {
          bucket[it.product_id] = {
            title: it.product_title || it.title,
            qty: q,
            tiers: (FAM.tiers && FAM.tiers[it.product_id]) || []
          };
        }
      });

      Object.keys(totals).forEach(function (key) {
        var fam = (FAM.fams || {})[key];
        if (!fam) return;
        var total = totals[key];
        var manque = fam.minimum && total < fam.minimum ? fam.minimum - total : 0;
        var unite = fam.unite || T.famUnit;

        var wrap = document.createElement('div');
        wrap.className = 'pz-fam' + (manque ? ' pz-fam--short' : '');

        var head = document.createElement('div');
        head.className = 'pz-fam__head';
        var name = document.createElement('span');
        name.className = 'pz-fam__name';
        name.textContent = fam.libelle || key;
        var count = document.createElement('span');
        count.className = 'pz-fam__count';
        count.textContent = trn(T.famUnitCountOne, T.famUnitCountOther, total, { count: total, unit: unite });
        head.appendChild(name);
        head.appendChild(count);
        wrap.appendChild(head);

        function track(parent, now, max, mini) {
          var t = document.createElement('div');
          t.className = 'pz-fam__track' + (mini ? ' pz-fam__track--mini' : '');
          t.setAttribute('role', 'progressbar');
          t.setAttribute('aria-valuenow', String(now));
          t.setAttribute('aria-valuemin', '0');
          t.setAttribute('aria-valuemax', String(max > 0 ? max : now));
          var b = document.createElement('div');
          b.className = 'pz-fam__fill';
          b.style.width = (max > 0 ? Math.min(100, Math.round(now * 100 / max)) : 100) + '%';
          t.appendChild(b);
          parent.appendChild(t);
        }

        function line(parent, cls, txt) {
          var d = document.createElement('div');
          d.className = 'pz-fam__line' + (cls ? ' ' + cls : '');
          d.textContent = txt;
          parent.appendChild(d);
        }

        /* La barre de gamme ne vise QUE le minimum. Elle visait auparavant le
           palier suivant calculé sur le total famille — ce qui promettait une
           remise que la caisse ne donnait pas : 6 Glass + 6 XL affichait
           « palier 12 atteint » alors que chacun des deux modèles est à 6. */
        track(wrap, total, manque ? fam.minimum : 0, false);

        if (manque) {
          line(wrap, 'pz-fam__line--warn',
            trn(T.famMinRequiredOne, T.famMinRequiredOther, fam.minimum, { count: fam.minimum, unit: unite })
            + ' ' + trn(T.famMinMissingOne, T.famMinMissingOther, manque, { count: manque })
            + (fam.panachage ? ' ' + T.famMixedSuffix : '') + '.');
        } else if (fam.minimum) {
          line(wrap, 'pz-fam__line--ok',
            trn(T.famMinReachedOne, T.famMinReachedOther, fam.minimum, { count: fam.minimum, unit: unite })
            + (fam.panachage ? T.famMixedClause : '') + '.');
        }

        /* Puis le détail par modèle, parce que c'est là que se joue le prix.
           Sans palier déclaré — les terreaux Monkey Soil n'en ont pas, juste un
           minimum — la section entière disparaît. */
        var bucket = prods[key] || {};
        var ids = Object.keys(bucket).filter(function (id) { return bucket[id].tiers.length; });
        if (!ids.length) { box.appendChild(wrap); return; }

        var sec = document.createElement('div');
        sec.className = 'pz-fam__prods';
        var st = document.createElement('div');
        st.className = 'pz-fam__prods-title';
        st.textContent = T.famTiersTitle;
        sec.appendChild(st);

        ids.forEach(function (id) {
          var e = bucket[id];
          var cur = null, nxt = null;
          e.tiers.forEach(function (p) {
            if (e.qty >= p.d) cur = p;
            else if (!nxt) nxt = p;
          });

          var row = document.createElement('div');
          row.className = 'pz-fam__prod';
          var rh = document.createElement('div');
          rh.className = 'pz-fam__prod-head';
          var rn = document.createElement('span');
          rn.className = 'pz-fam__prod-name';
          rn.textContent = e.title;
          var rc = document.createElement('span');
          rc.className = 'pz-fam__prod-count';
          rc.textContent = trn(T.famUnitCountOne, T.famUnitCountOther, e.qty, { count: e.qty, unit: unite });
          rh.appendChild(rn);
          rh.appendChild(rc);
          row.appendChild(rh);

          if (nxt) {
            var reste = nxt.d - e.qty;
            track(row, e.qty, nxt.d, true);
            line(row, 'pz-fam__line--next',
              trn(T.famNextTierOne, T.famNextTierOther, reste, { count: reste, unit: unite, price: nxt.p }));
          } else {
            track(row, 1, 1, true);
            line(row, 'pz-fam__line--next', T.famBestPrice);
          }
          if (cur) {
            line(row, 'pz-fam__line--won', tr(T.famTierApplied, { price: cur.p, from: cur.d }));
          }
          sec.appendChild(row);
        });

        wrap.appendChild(sec);
        box.appendChild(wrap);
      });
    }

    function render(cart) {
      linesEl.innerHTML = '';
      var has = cart.item_count > 0;
      emptyEl.hidden = has;
      footEl.hidden = !has;
      linesEl.hidden = !has;
      countEl.textContent = has
        ? '(' + trn(T.itemsOne, T.itemsOther, cart.item_count, { count: cart.item_count }) + ')'
        : '';

      cart.items.forEach(function (item) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        var thumb = $('[data-pz-mcthumb]', node);
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        } else {
          thumb.textContent = (item.product_title || '?').charAt(0).toUpperCase();
        }

        $('[data-pz-mcbrand]', node).textContent = item.vendor || '';
        var titleEl = $('[data-pz-mctitle]', node);
        titleEl.textContent = item.product_title;
        titleEl.href = item.url;

        var bits = [];
        if (item.sku) bits.push('Réf. ' + item.sku);
        if (item.variant_title && item.variant_title !== 'Default Title') bits.push(item.variant_title);
        $('[data-pz-mcref]', node).textContent = bits.join(' · ');

        $('[data-pz-mclinetotal]', node).textContent = money(item.final_line_price);
        $('[data-pz-mcunit]', node).textContent = money(item.final_price) + ' · ' + unitLabel(item);

        var qty = $('[data-pz-mcqty]', node);
        qty.value = item.quantity;

        function change(next) {
          if (busy) return;
          busy = true;
          panel.style.opacity = '.55';
          postJSON(R.cartChange || '/cart/change.js', { id: item.key, quantity: Math.max(0, next) })
            .then(render)
            .catch(function (e) { alert(e.message || T.genericError); })
            .then(function () { busy = false; panel.style.opacity = ''; syncBadge(); });
        }

        $('[data-pz-mcdec]', node).addEventListener('click', function () { change(item.quantity - 1); });
        $('[data-pz-mcinc]', node).addEventListener('click', function () { change(item.quantity + 1); });
        $('[data-pz-mcrm]',  node).addEventListener('click', function () { change(0); });
        qty.addEventListener('change', function () { change(parseInt(qty.value, 10) || 0); });

        linesEl.appendChild(node);
      });

      subEl.textContent = money(cart.total_price);
      renderFamilles(cart);

      /* Le compteur de l'en-tête n'était mis à jour que par syncBadge(), que
         open() n'appelait pas : après un ajout, le tiroir montrait le bon
         contenu mais la pastille restait sur l'ancien chiffre jusqu'au
         rechargement. Le rendre ici couvre tous les chemins d'un coup. */
      $$('.pz-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    }

    function refresh() { return getCart().then(render).catch(function () {}); }

    function syncBadge() {
      getCart().then(function (cart) {
        $$('.pz-cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    }

    $$('[data-pz-mcclose]', root).forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /* Le bouton panier de l'en-tête ouvre le drawer au lieu de naviguer. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.pz-cart-btn');
      if (!btn) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      open();
    });

    return { open: open, close: close, refresh: refresh, syncBadge: syncBadge };
  })();

  /* ── Actions rapides sur la page recherche ─────────────── */

  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('[data-pz-step]');
    if (step) {
      var wrap = step.closest('.pzb-stepper');
      var input = wrap && $('[data-pz-qty]', wrap);
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        var d = parseInt(step.getAttribute('data-pz-step'), 10);
        input.value = Math.max(1, v + d);
      }
      return;
    }

    var add = e.target.closest && e.target.closest('[data-pz-add]');
    if (!add) return;
    var row = add.closest('.pz-srow');
    var qtyEl = row && $('[data-pz-qty]', row);
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var label = add.textContent;
    add.disabled = true;
    add.textContent = '…';
    postJSON(R.cartAdd || '/cart/add.js', { items: [{ id: Number(add.getAttribute('data-pz-add')), quantity: qty }] })
      .then(function () {
        add.textContent = 'Ajouté ✓';
        if (MC) { MC.syncBadge(); MC.open(); }
        setTimeout(function () { add.textContent = label; add.disabled = false; }, 1200);
      })
      .catch(function (err) {
        alert(err.message || T.genericError);
        add.textContent = label;
        add.disabled = false;
      });
  });

  /* ── Commande rapide ────────────────────────── */

  (function quickOrder() {
    var root = $('[data-pz-quick]');
    if (!root) return;

    var rowsEl   = $('[data-pz-qrows]', root);
    var tpl      = $('[data-pz-qtpl]', root);
    var skuList  = $('[data-pz-skulist]', root);
    var submitEl = $('[data-pz-vsubmit]', root);
    var statusEl = $('[data-pz-vstatus]', root);

    var MAX_CSV = 500;

    function rows() { return $$('[data-pz-qrow]', rowsEl); }

    function addRow(sku, qty, defer) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var skuEl = $('[data-pz-qsku]', node);
      var qtyEl = $('[data-pz-qqty]', node);
      if (sku) skuEl.value = sku;
      if (qty) qtyEl.value = qty;

      var debounce;
      skuEl.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { lookup(node); }, 320);
      });
      qtyEl.addEventListener('input', function () { paint(node); tally(); });
      $('[data-pz-qremove]', node).addEventListener('click', function () {
        node.remove();
        if (!rows().length) addRow();
        tally();
      });

      rowsEl.appendChild(node);
      if (sku && !defer) lookup(node);
      return node;
    }

    function lookup(node) {
      var sku = $('[data-pz-qsku]', node).value.trim();
      node._resolved = null;
      if (!sku) { paint(node); tally(); return Promise.resolve(); }
      $('[data-pz-qtitle]', node).textContent = 'Recherche…';
      return resolveSku(sku).then(function (hit) {
        node._resolved = hit;
        if (hit) {
          var opt = document.createElement('option');
          opt.value = hit.variant.sku;
          opt.textContent = hit.product.title;
          if (!$('option[value="' + CSS.escape(hit.variant.sku) + '"]', skuList)) skuList.appendChild(opt);
        }
        paint(node);
        tally();
      });
    }

    function paint(node) {
      var hit    = node._resolved;
      var qty    = parseInt($('[data-pz-qqty]', node).value, 10) || 0;
      var title  = $('[data-pz-qtitle]', node);
      var meta   = $('[data-pz-qmeta]', node);
      var stock  = $('[data-pz-qstock]', node);
      var total  = $('[data-pz-qtotal]', node);
      var sku    = $('[data-pz-qsku]', node).value.trim();

      node.classList.remove('pz-qrow--bad', 'pz-qrow--low');

      if (!sku) {
        title.textContent = '—';
        title.classList.add('pz-qrow-title--empty');
        meta.textContent = ''; stock.innerHTML = ''; total.textContent = '—';
        return;
      }
      if (!hit) {
        title.textContent = 'Référence introuvable';
        title.classList.remove('pz-qrow-title--empty');
        meta.textContent = ''; stock.innerHTML = ''; total.textContent = '—';
        node.classList.add('pz-qrow--bad');
        return;
      }

      title.textContent = hit.product.title;
      title.classList.remove('pz-qrow-title--empty');
      var m = [hit.product.vendor];
      if (hit.variant.title && hit.variant.title !== 'Default Title') m.push(hit.variant.title);
      meta.textContent = m.filter(Boolean).join(' · ');

      if (hit.variant.available) {
        stock.innerHTML = '<span class="pzb-stock pzb-stock--ok">' + T.inStock + '</span>';
      } else {
        stock.innerHTML = '<span class="pzb-stock pzb-stock--no">' + T.onOrder + '</span>';
        node.classList.add('pz-qrow--low');
      }
      total.textContent = qty > 0 ? money(hit.variant.price * qty) : '—';
    }

    function tally() {
      var ok = 0, bad = 0, low = 0, sum = 0;
      var issues = [];

      rows().forEach(function (node) {
        var sku = $('[data-pz-qsku]', node).value.trim();
        if (!sku) return;
        var qty = parseInt($('[data-pz-qqty]', node).value, 10) || 0;
        var hit = node._resolved;
        if (!hit) {
          bad++;
          issues.push({ sku: sku, msg: T.unknownSku, color: 'var(--pzb-danger)' });
          return;
        }
        if (qty < 1) {
          bad++;
          issues.push({ sku: sku, msg: 'quantité invalide', color: 'var(--pzb-danger)' });
          return;
        }
        ok++;
        sum += hit.variant.price * qty;
        if (!hit.variant.available) {
          low++;
          issues.push({ sku: sku, msg: T.outOfStock + ' ' + T.willBackorder, color: 'var(--pzb-warn)' });
        }
      });

      $('[data-pz-vok]',    root).textContent = ok;
      $('[data-pz-vbad]',   root).textContent = bad;
      $('[data-pz-vlow]',   root).textContent = low;
      $('[data-pz-vtotal]', root).textContent = ok ? money(sum) : '—';
      $('[data-pz-vcount]', root).textContent = ok;
      submitEl.disabled = ok === 0;

      var box = $('[data-pz-vissues]', root);
      var list = $('[data-pz-vissuelist]', root);
      list.innerHTML = '';
      box.hidden = issues.length === 0;
      issues.slice(0, 12).forEach(function (i) {
        var d = document.createElement('div');
        d.className = 'pzb-issue';
        var s = document.createElement('strong');
        s.style.color = i.color;
        s.textContent = i.sku;
        d.appendChild(s);
        d.appendChild(document.createTextNode(' — ' + i.msg));
        list.appendChild(d);
      });
    }

    /* Boutons de la barre d'actions */
    $('[data-pz-qadd]', root).addEventListener('click', function () { addRow(); });
    $('[data-pz-qadd10]', root).addEventListener('click', function () {
      for (var i = 0; i < 10; i++) addRow();
    });
    $('[data-pz-qclear]', root).addEventListener('click', function () {
      rowsEl.innerHTML = '';
      for (var i = 0; i < 4; i++) addRow();
      tally();
    });

    /* Import CSV */
    var drop = $('[data-pz-drop]', root);
    var file = $('[data-pz-file]', root);
    drop.addEventListener('click', function () { file.click(); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer.files && e.dataTransfer.files[0]) readCsv(e.dataTransfer.files[0]);
    });
    file.addEventListener('change', function () { if (file.files[0]) readCsv(file.files[0]); });

    $('[data-pz-template]', root).addEventListener('click', function (e) {
      e.preventDefault();
      var blob = new Blob(['﻿sku;quantite\nPZ-0001;12\nPZ-0002;6\n'], { type: 'text/csv;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'prozone-commande-rapide.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    });

    /* Découpe une ligne CSV en respectant les guillemets. */
    function splitCsvLine(line, delim) {
      var out = [], cur = '', q = false, i;
      for (i = 0; i < line.length; i++) {
        var ch = line.charAt(i);
        if (q) {
          if (ch === '"') { if (line.charAt(i + 1) === '"') { cur += '"'; i++; } else { q = false; } }
          else cur += ch;
        } else if (ch === '"') { q = true; }
        else if (ch === delim) { out.push(cur); cur = ''; }
        else cur += ch;
      }
      out.push(cur);
      return out.map(function (c) { return c.trim(); });
    }

    /* Quantité : accepte 12, 12.0, 12,0 et 1'200 (format suisse). null = invalide. */
    function toQty(raw) {
      if (raw == null) return null;
      var t = String(raw).trim().replace(/[\s']/g, '').replace(',', '.');
      if (!/^-?\d+(\.\d+)?$/.test(t)) return null;
      var n = Number(t);
      if (!isFinite(n) || n <= 0) return null;
      return Math.round(n);
    }

    function parseCsv(text) {
      var lines = text.replace(/^\ufeff/, '').split(/\r\n|\r|\n/).filter(function (l) { return l.trim(); });
      if (!lines.length) return { rows: [], skipped: [] };
      var head = lines[0];
      var delim = (head.split(';').length > head.split(',').length) ? ';'
                : (head.split('\t').length > head.split(',').length) ? '\t' : ',';
      var first = splitCsvLine(head, delim);
      /* En-tête : soit la 1re cellule est un libellé connu, soit la 2e n'est pas une quantité. */
      var isHeader = /^(sku|ref|r[ée]f[ée]rence|artikel|artikelnummer|article|item)$/i.test(first[0] || '')
                  || toQty(first[1]) === null;
      var rows = [], skipped = [];
      lines.forEach(function (line, idx) {
        if (idx === 0 && isHeader) return;
        var cells = splitCsvLine(line, delim);
        var sku = cells[0] || '';
        var qty = toQty(cells[1]);
        if (!sku) { skipped.push(idx + 1); return; }
        if (qty === null) { skipped.push(idx + 1); return; }
        rows.push({ sku: sku, qty: qty });
      });
      return { rows: rows, skipped: skipped };
    }

    function readCsv(f) {
      var reader = new FileReader();
      reader.onload = function () {
        var res = parseCsv(String(reader.result));
        var parsed = res.rows;
        var skipped = res.skipped;
        if (!parsed.length) {
          statusEl.textContent = skipped.length
            ? 'Aucune ligne exploitable : ' + skipped.length + ' ligne(s) rejetée(s) (quantité absente ou invalide).'
            : 'Aucune ligne exploitable dans ce fichier.';
          return;
        }
        var truncated = parsed.length > MAX_CSV;
        parsed = parsed.slice(0, MAX_CSV);

        rowsEl.innerHTML = '';
        var nodes = parsed.map(function (p) { return addRow(p.sku, p.qty, true); });

        statusEl.textContent = 'Vérification de ' + parsed.length + ' lignes…';
        pool(nodes, 6, lookup).then(function () {
          var msg = truncated
            ? 'Import limité aux ' + MAX_CSV + ' premières lignes.'
            : parsed.length + ' lignes importées et vérifiées.';
          if (skipped.length) {
            msg += ' ' + skipped.length + ' ligne(s) ignorée(s) (ligne ' + skipped.slice(0, 5).join(', ')
                 + (skipped.length > 5 ? '…' : '') + ') : quantité absente ou invalide.';
          }
          statusEl.textContent = msg;
          tally();
        });
      };
      reader.readAsText(f, 'utf-8');
    }

    /* Ajout groupé au panier */
    submitEl.addEventListener('click', function () {
      var items = [];
      rows().forEach(function (node) {
        var hit = node._resolved;
        var qty = parseInt($('[data-pz-qqty]', node).value, 10) || 0;
        if (hit && qty > 0) items.push({ id: hit.variant.id, quantity: qty });
      });
      if (!items.length) return;

      submitEl.disabled = true;
      statusEl.textContent = 'Ajout au panier…';
      postJSON(R.cartAdd || '/cart/add.js', { items: items })
        .then(function () {
          statusEl.textContent = items.length + ' lignes ajoutées au panier.';
          if (MC) { MC.syncBadge(); MC.open(); }
        })
        .catch(function (err) { statusEl.textContent = err.message || T.genericError; })
        .then(function () { submitEl.disabled = false; });
    });

    for (var i = 0; i < 4; i++) addRow();
    tally();
  })();
})();
